/* eslint-disable no-new */

import { getVariantFromOptionArray } from '@shopify/theme-product'
import formatMoney from '../utilities/shopify-format-money.js'
import { swiperDefaults } from '../globals.js'
import Swiper from 'swiper'
import { A11y, Navigation, Pagination } from 'swiper/modules'
import reframe from 'reframe.js'

/**
 * Product Variant Switching
 */
const optionSelectors = document.querySelectorAll('[data-product-option]')
let lastClick = 0
/**
 *
 */
const handleProductOptionChange = (event) => {
    const masterSelect = document.querySelector('#product-select')
    const options = masterSelect.querySelectorAll('option')
    const specsSection = document.querySelectorAll('.productSpecifications__variantWrapper .productPill input')
    const optionsArray = [...optionSelectors].map((option) => option.querySelector(':checked').value)
    const selectedVariant = getVariantFromOptionArray(window.product.data, optionsArray)
    const priceElement = document.querySelector('[data-price]')

    if (!selectedVariant) {
        const addToCartButton = document.querySelector('.addToCart')
        priceElement.innerHTML = '<br>'
        addToCartButton.innerHTML = 'Unavailable'
        addToCartButton.setAttribute('disabled', 'disabled')
        return
    }

    let format
    if (priceElement.getAttribute('name') === 'CA') {
        format = '${{amount}} CAD'
    } else {
        format = '${{amount}}'
    }

    const selectedVariantQuantity = window.product.inventory[selectedVariant.id]
    const { target } = event
    let { internalId } = target.dataset

    priceElement.innerHTML = formatMoney(selectedVariant.price, format)

    if (selectedVariant.compare_at_price) {
        priceElement.innerHTML = `<del>${formatMoney(selectedVariant.compare_at_price, format)}</del> ${formatMoney(selectedVariant.price, format)}`
    } else {
        priceElement.innerHTML = formatMoney(selectedVariant.price, format)
    }

    if (!internalId) {
        options.forEach(item => {
            const attr = item.getAttribute('data-internal-id')
            if (item.getAttribute('value') === selectedVariant.id.toString()) {
                internalId = attr
            }
        })
    }

    if ('$BV' in window) {
        window.$BV.ui('rr', 'show_reviews', {
            productId: internalId
        })
    }

    masterSelect.value = selectedVariant.id
    masterSelect.dispatchEvent(new Event('change'))

    handleAddToCartButtonStateUpdate(selectedVariant)
    handleInventoryNoticeDisplay(selectedVariantQuantity)
    handleVariantUrlUpdate(selectedVariant.id)

    // Update afterpay message with variant price
    const afterpayEl = document.querySelector('square-placement')
    if (afterpayEl && afterpayEl.shadowRoot) {
        const variantPrice = formatMoney(selectedVariant.price, format)
        const apTotalPrice = document.querySelector('.afterpay__total-price')
        apTotalPrice.innerHTML = variantPrice
    }

    // trigger specs update
    specsSection.forEach(item => {
        const attr = item.getAttribute('data-internal-id')
        if (attr === selectedVariant.id.toString()) {
            item.click()
        }
    })

    // Locally method to reload product locator
    if ((lastClick + 1000) < Date.now()) {
        lcly_reload_0({ upc: selectedVariant.sku })
        lastClick = Date.now()
    }
}

/**
 *
 * @param variantId
 */
const handleVariantUrlUpdate = (variantId) => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.set('variant', variantId)
    window.history.replaceState({}, '', `${location.pathname}?${searchParams}`)
}

if (optionSelectors) {
    optionSelectors.forEach((optionSelector) => {
        optionSelector.addEventListener('change', handleProductOptionChange)
    })
}

/**
 *
 * @param variantAvailableQuantity
 */
const handleInventoryNoticeDisplay = (variantAvailableQuantity) => {
    const inventoryNotice = document.querySelector('[data-inventory-notice]')

    if (variantAvailableQuantity <= 5 && variantAvailableQuantity > 0) {
        inventoryNotice.innerHTML = `Only ${variantAvailableQuantity} left in stock!`
        return
    }

    inventoryNotice.innerHTML = ''
}

/**
 *
 * @param variantAvailable
 */
const handleAddToCartButtonStateUpdate = (selectedVariant) => {
    const addToCartButton = document.querySelector('.addToCart')
    const outOfStock = window.variantsMeta.metafields[`${selectedVariant.id}`]

    if (!selectedVariant.available) {
        addToCartButton.innerHTML = outOfStock ? 'Out of Stock' : 'Sold Out | <span onclick="openBackInStockModal()" class="trellis-bis-trigger" style="text-decoration: underline; cursor: pointer;">Join the waitlist</span>'
        addToCartButton.setAttribute('disabled', 'disabled')
        return
    }

    addToCartButton.innerHTML = 'Add to Cart'
    addToCartButton.removeAttribute('disabled')
}

/**
 * Product Gallery Slider
 */
new Swiper('[data-product-gallery]', {
    ...swiperDefaults,
    lazy: true,
    centeredSlides: true,
    slidesPerView: 1.75,
    loop: true,
    modules: [Pagination, Navigation, A11y]
})

/**
 * Product Video Slider
 */
let videoGallerySwiper = null

// Initialize video gallery swiper if it exists
if (document.querySelector('[data-video-gallery]')) {
    videoGallerySwiper = new Swiper('[data-video-gallery]', {
        ...swiperDefaults,
        slidesPerView: 1.05,
        spaceBetween: 30,
        modules: [Pagination, Navigation, A11y]
    })
}

// Remove unnecessary aria attributes from swiper
setTimeout(() => {
    const ariaLiveEls = document.querySelectorAll('.swiper [aria-live]')
    const ariaAtomicEls = document.querySelectorAll('.swiper [aria-atomic]')
    const ariaControlsEls = document.querySelectorAll('.swiper [aria-controls]')
    
    ariaLiveEls.forEach(el => el.removeAttribute('aria-live'))
    ariaAtomicEls.forEach(el => el.removeAttribute('aria-atomic'))
    ariaControlsEls.forEach(el => el.removeAttribute('aria-controls'))
}, 500)

/**
 * Product Feature Slider
 */
new Swiper('[data-feature-slider]', {
    ...swiperDefaults,
    slidesPerView: 1.25,
    spaceBetween: 30,
    lazy: true,
    loop: true,
    centeredSlides: true,
    modules: [Navigation, A11y],
    breakpoints: {
        701: {
            slidesPerView: 1.5
        },
        951: {
            slidesPerView: 2.5
        },
        1280: {
            slidesPerView: 3.5
        }
    }
})

/**
 * Related Products Slider
 */
const mediaQuery = window.matchMedia('(max-width:59.375em)')
let swiperInstance = false

function handleResizeChange (e) {
    // Check if the media query is true
    if (e.matches) {
        if (document.querySelector('[data-related-products-slider]')) {
            swiperInstance = new Swiper('[data-related-products-slider]', {
                ...swiperDefaults,
                slidesPerView: 1.5,
                spaceBetween: 30,
                modules: [Navigation, A11y],
                breakpoints: {
                    700: {
                        slidesPerView: 2.5
                    }
                }
            })
            return
        }
    }

    if (swiperInstance) swiperInstance.destroy(true, true)
}

// Register event listener
mediaQuery.addListener(handleResizeChange)

// Initial check
handleResizeChange(mediaQuery)

/**
 * YouTube Video Player Initialization
 */
class YouTubeVideoGallery {
    constructor() {
        this.players = {}
        this.initialized = false
        this.userHasPlayed = {} // Track which videos user has actually played
        this.init()
    }

    init() {
        if (this.initialized) return
        this.initialized = true

        // Wait for YouTube API to be ready
        if (window.YT && window.YT.ready) {
            window.YT.ready(() => this.initializePlayers())
        } else {
            // Fallback: try again after a short delay
            setTimeout(() => this.init(), 100)
        }
    }

    initializePlayers() {
        const playButtons = document.querySelectorAll('.youtube-play-button')
        
        playButtons.forEach((button) => {
            const videoId = button.getAttribute('data-video-id')
            const container = button.closest('.youtube-video-container')
            const playerContainer = container.querySelector('.youtube-player-container')
            const thumbnail = container.querySelector('.youtube-thumbnail')
            const playIcon = container.querySelector('.youtube-play-icon')
            
            // Ensure thumbnail and play icon are visible by default
            if (thumbnail) thumbnail.style.display = 'block'
            if (playIcon) playIcon.style.display = 'block'
            button.style.display = 'block'
            
            // Create YouTube player on page load (this is fine)
            if (videoId && playerContainer) {
                setTimeout(() => {
                    this.createPlayer(videoId, playerContainer, button)
                }, 100)
            }
            
            // Add click handler to play button
            button.addEventListener('click', () => {
                // Hide thumbnail and play button immediately when user clicks
                button.style.display = 'none'
                if (thumbnail) thumbnail.style.display = 'none'
                if (playIcon) playIcon.style.display = 'none'
                
                this.userHasPlayed[videoId] = true // Mark that user has clicked play
                
                // Play the video
                if (this.players[videoId]) {
                    this.players[videoId].playVideo()
                }
            })
        })
    }

    createPlayer(videoId, container, playButton) {
        try {
            // Get the container dimensions - use 100% to let CSS handle sizing
            const containerWidth = container.offsetWidth || '100%'
            const containerHeight = container.offsetHeight || '100%'
            
            this.players[videoId] = new window.YT.Player(container, {
                videoId: videoId,
                width: containerWidth,
                height: containerHeight,
                playerVars: {
                    autoplay: 0,
                    controls: 1,
                    modestbranding: 1,
                    rel: 0
                },
                events: {
                    onReady: (event) => this.onPlayerReady(event, playButton)
                }
            })
        } catch (error) {
            console.error(`Error creating YouTube player for ${videoId}:`, error)
        }
    }

    onPlayerReady(event, playButton) {
        const iframe = event.target.getIframe()
        if (iframe) {
            reframe(iframe)
        }

        // Update swiper if it exists
        if (videoGallerySwiper && videoGallerySwiper.update) {
            videoGallerySwiper.update()
        }
    }

}

// Initialize YouTube video gallery
if (document.querySelector('.youtube-video-container')) {
    new YouTubeVideoGallery()
}
